/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PromotionStatus;

(function (PromotionStatus) {
  PromotionStatus["ACTIVE"] = "active";
  PromotionStatus["INACTIVE"] = "inactive";
})(PromotionStatus || (PromotionStatus = {}));